import { useMutation } from '@apollo/client'
import { SetJapaneseGroup, SetJapaneseGroupVariables } from '../../types'
import { SET_JAPANESE_GROUP } from './operations'

export const useSetJapaneseGroup = () =>
  useMutation<SetJapaneseGroup, SetJapaneseGroupVariables>(SET_JAPANESE_GROUP)
